import React, { Component } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import ReactTooltip from "react-tooltip";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { filterByLanguage } from "../../../utils/functions.js";
import BootstrapSwitchButton from 'bootstrap-switch-button-react'
import { getUsers } from '../../../utils/UsersAPI.js';
import { sortByField } from '../../../utils/UIUtils';

export class AddUserModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: this.props.show,

      users: null,
    }

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(event) {
     event.preventDefault();

    this.props.onOK(this.user.value)
 }

 getUsers() {
   getUsers()
     .then(response => {
       this.setState({ users: response.data.sort((a,b) => sortByField('name', a, b)) });
     })
     .catch(error => {
       console.error(error);
     });
 }

 componentDidMount() {
   this.getUsers();
 }

  render() {
    // console.log(this.props.datasets)
    return (
      <Modal show={this.props.show} onHide={this.props.onClose} animation={false} backdrop="static">
        <Form onSubmit={this.handleSubmit}>
          <Modal.Header>
            <Modal.Title>Add user</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group>
              <Form.Label>User</Form.Label>

              <Form.Control as="select" ref={node => (this.user = node)}
                    defaultValue=''
                    required>
                  <option disabled hidden value=''></option>
                  {this.state.users && this.state.users.map((user, index) =>
                    <option key={index} value={user.id}>{user.name} ({user.email})</option>
                  )}
              </Form.Control>

            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button type="submit" variant="primary">
              OK
            </Button>
            <Button variant="secondary" onClick={this.props.onClose}>
              Cancel
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
  )}
}

export default AddUserModal;
